import { Comments } from "../Comments/Comments";
import { Collaborators } from "../Collaborators/Collaborators";

interface CommentsAndCollaboratorsViewProps {
  onAddCollaborator?: () => void;
}

export const CommentsAndCollaboratorsView = ({ onAddCollaborator }: CommentsAndCollaboratorsViewProps) => {
  return (
    <div className="space-y-6">
      <Comments />
      
      {/* Divider */}
      <div className="border-t border-white/10" />
      
      <Collaborators onAddCollaborator={onAddCollaborator} />
    </div>
  );
};
